import { formatearFechaCompleta } from '../../utils/utils'
import React from 'react'

const ListaExperienciaLaboral = ({experienciaLaboral,oneliminarExperiencia}) => {
  return (
     <div className="space-y-6">
      
      {experienciaLaboral.length > 0 ? (
        <div className="space-y-4 mb-6">
          {experienciaLaboral.map((exp, index) => (
            <div key={index} className="border p-4 rounded-lg">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold text-lg">{exp.nombrEmpresa}</h3>
                  <p className="text-gray-600">{exp.modalidad}</p>
                  <p className="text-sm text-gray-500">
                    {formatearFechaCompleta(exp.fechaIncio)} - 
                    {exp.trabajandoActualmente ? ' Actual' : ` ${formatearFechaCompleta(exp.fechaFinal)}`}
                  </p>
                  <p className="mt-2">{exp.descripcion}</p>
                </div>

                {oneliminarExperiencia && (
                  <button 
                    className="text-red-500 hover:text-red-700"
                    onClick={() => oneliminarExperiencia(index)}
                  >
                    Eliminar
                  </button>
                )}

                
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center p-8 border border-dashed rounded-lg text-gray-500">
          No has añadido experiencia laboral aún
        </div>
      )}
      
    </div>
  )
}

export default ListaExperienciaLaboral
